import AdsRunCard from './AdsRunCard';

export default AdsRunCard;
